// extracted by mini-css-extract-plugin
export default {"base":"CbsaStat_base__AiDRZ","btn":"CbsaStat_btn__BjJmh"};